import {
  FETCH_CERTIFICATES_REQUEST,
  FETCH_CERTIFICATES_SUCCESS,
  FETCH_CERTIFICATES_FAILURE,
  FETCH_CERTIFICATE_DETAIL_REQUEST,
  FETCH_CERTIFICATE_DETAIL_SUCCESS,
  FETCH_CERTIFICATE_DETAIL_FAILURE,
  CREATE_CERTIFICATE_REQUEST,
  CREATE_CERTIFICATE_SUCCESS,
  CREATE_CERTIFICATE_FAILURE,
  DELETE_CERTIFICATES_BY_TASK_REQUEST,
  DELETE_CERTIFICATES_BY_TASK_SUCCESS,
  DELETE_CERTIFICATES_BY_TASK_FAILURE,
  CHECK_CERTIFICATE_PURCHASE_STATUS_REQUEST,
  CHECK_CERTIFICATE_PURCHASE_STATUS_SUCCESS,
  CHECK_CERTIFICATE_PURCHASE_STATUS_FAILURE,
  MARK_CERTIFICATE_PURCHASED_REQUEST,
  MARK_CERTIFICATE_PURCHASED_SUCCESS,
  MARK_CERTIFICATE_PURCHASED_FAILURE,
} from '../types/certificateTypes';

const initialState = {
  items: [],
  total: 0,
  count: 0,
  loading: false,
  error: null,

  detail: null,
  detailLoading: false,
  detailError: null,

  createLoading: false,
  createError: null,
  lastCreated: null,

  deleteLoading: false,
  deleteError: null,
  lastDeleted: null,

  purchaseStatusLoading: false,
  purchaseStatusError: null,
  purchaseStatus: null,

  markPurchasedLoading: false,
  markPurchasedError: null,
  lastMarkedPurchased: null,
};

export default function certificateReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CERTIFICATES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CERTIFICATES_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload?.items || action.payload?.objects?.items || [],
        total: action.payload?.objects?.total || 0,
        count: action.payload?.objects?.count || 0,
      };
    case FETCH_CERTIFICATES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_CERTIFICATE_DETAIL_REQUEST:
      return { ...state, detailLoading: true, detailError: null, detail: null };
    case FETCH_CERTIFICATE_DETAIL_SUCCESS:
      return { ...state, detailLoading: false, detail: action.payload || null };
    case FETCH_CERTIFICATE_DETAIL_FAILURE:
      return { ...state, detailLoading: false, detailError: action.payload };

    case CREATE_CERTIFICATE_REQUEST:
      return { ...state, createLoading: true, createError: null, lastCreated: null };
    case CREATE_CERTIFICATE_SUCCESS:
      return { ...state, createLoading: false, lastCreated: action.payload || null };
    case CREATE_CERTIFICATE_FAILURE:
      return { ...state, createLoading: false, createError: action.payload };

    case DELETE_CERTIFICATES_BY_TASK_REQUEST:
      return { ...state, deleteLoading: true, deleteError: null, lastDeleted: null };
    case DELETE_CERTIFICATES_BY_TASK_SUCCESS:
      return { ...state, deleteLoading: false, lastDeleted: action.payload || null };
    case DELETE_CERTIFICATES_BY_TASK_FAILURE:
      return { ...state, deleteLoading: false, deleteError: action.payload };

    case CHECK_CERTIFICATE_PURCHASE_STATUS_REQUEST:
      return { ...state, purchaseStatusLoading: true, purchaseStatusError: null, purchaseStatus: null };
    case CHECK_CERTIFICATE_PURCHASE_STATUS_SUCCESS:
      return { ...state, purchaseStatusLoading: false, purchaseStatus: action.payload || null };
    case CHECK_CERTIFICATE_PURCHASE_STATUS_FAILURE:
      return { ...state, purchaseStatusLoading: false, purchaseStatusError: action.payload };

    case MARK_CERTIFICATE_PURCHASED_REQUEST:
      return { ...state, markPurchasedLoading: true, markPurchasedError: null, lastMarkedPurchased: null };
    case MARK_CERTIFICATE_PURCHASED_SUCCESS:
      return {
        ...state,
        markPurchasedLoading: false,
        lastMarkedPurchased: action.payload || null,
        purchaseStatus: state.purchaseStatus
          ? { ...state.purchaseStatus, purchased: true }
          : state.purchaseStatus,
      };
    case MARK_CERTIFICATE_PURCHASED_FAILURE:
      return { ...state, markPurchasedLoading: false, markPurchasedError: action.payload };

    default:
      return state;
  }
}

